import { Code } from '#app/components/typography/code'
import { H1 } from '#app/components/typography/h1.tsx'
import { H2 } from '#app/components/typography/h2.tsx'
import { P } from '#app/components/typography/p.tsx'
import { CodeBlock } from '#app/old/components/data-display/code-block'
import flexAPI from './flex-api.png'
import triggerSuggest from './trigger-suggest.png'

export default function LayoutRoute() {
	return (
		<>
			<H1>Layout</H1>
			<P className="text-lg">Components that pertain to layout.</P>

			<H2>Better map of the terrain</H2>
			<P>
				Creating a component for each type of layout (<Code>{'<Flex />'}</Code>, <Code>{'<Grid />'}</Code>, <Code>{'<Container />'}</Code>, <Code>{'<Sticky />'}</Code>, etc) gives you a
				better "map of the terrain" and makes it easier to know which tool to reach for when you need to create a layout.
			</P>

			<H2>Accessibility</H2>
			<P>
				These components also purposely disallow{' '}
				<a href="https://andrecasal.com/articles/the-dark-side-of-the-grid" target="_blank" rel="noreferrer" className="underline">
					inaccessible CSS features
				</a>
				.
			</P>

			<H2>Informative API</H2>
			<P>You get a clear API that informs you of the values you can manipulate on each layout mode.</P>
			<P>
				Here's an example for the <Code>Flex</Code> component.
			</P>
			<CodeBlock
				className="max-w-2xl"
				code={`<Flex direction="col" justify="between" items="center" gap="6">
	<Item1 />
	<Item2 />
	<Item2 />
	<Item3 />
</Flex>`}
				filename="flex"
				extension="tsx"
			/>
			<P>And here's how you can see the available props and their types in VS Code.</P>
			<img src={flexAPI} alt="Flex API" className="mt-6 max-w-2xl rounded-xl" />
			<P>
				Unfortunately, VS Code still{' '}
				<a href="https://github.com/microsoft/TypeScript/issues/52080" target="_blank" rel="noreferrer" className="underline">
					displays props in alphabetical order
				</a>{' '}
				instead of showing component props at the top when running "trigger suggest".
			</P>
			<img src={triggerSuggest} alt="Flex API" className="mt-6 max-w-2xl rounded-xl" />
		</>
	)
}
